import {
   AutoComplete,
  Button,
  CIInfoIcon,
  CILabel,
  Loader, Modal,
  Radio,
  Textarea,
  accessToken
} from 'ccs-ui-components';
import { debounce } from 'lodash';
import { useEffect, useReducer, useRef, useState } from 'react';
import axios from 'axios';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import FileUploadButton from '../../../../../../_components/file-upload/FileUploadButton';
import { AUTOCOMPLETE_FIELD, AUTH_TYPE_NAME, DEBOUNCE_DELAY, HELP_CENTER_CHATPAGE_SERVICE_BASE_URL, OPERATION_VERB, SERVICE_MODE, SERVICE_TYPE_KEY, VER, associationEventType } from '../../../../../../constants';
import { useIngressEventForm } from '../../../../../../hooks';
import { IIngressEventMappingModel, IIngressEventValidationModel, IngressEventFormData } from '../../../../../../models/index';
import { AppDispatch, useSelector } from '../../../../../../store/AppStore';
import { fetchEventRequest } from '../../../../../../store/actions/sagaActions/events/EventNameSagaActions';
import {
  fetchServiceEventRequest
} from '../../../../../../store/actions/sagaActions/services/IngressServiceEventSagaActions';
import { IActiveServiceEvent } from '../../../../../../store/actions/types/services/GetAllServiceEventTypes';
import { deleteEgressEventMappingOfIngress } from '../../../../../../store/reducer/services/EgressEventMappingReducer';
import {
  addIngressEventMapping,
  updateIngressEventMapping
} from '../../../../../../store/reducer/services/IngressEventMappingReducer';
import { callGetServiceAssociatedEventApi } from '../../../../../../store/sagas/services/FetchServiceEventSaga';
import { getSchemaForEvent } from '../../../../../../utilities/services/ServiceDetailsUtils';
import {
  constructIngressEventObject, isIngressEventDetailsUpdated
} from '../../../../../../utilities/services/ServiceEventAssociationUtils';
import { getModeFromUrl } from '../../../../../../utilities/services/ServiceListUtils';
import { JoltConfigurations } from '../../../../../jolt-mapping-configuration/JoltMappingConfiguration';
import EventSchemaTree from '../association-event-schema/AssociationEventSchema';
import {
  INGRESS_EVENT_FORM_ACTIONS,
  exceptionFormInitialState,
  getExceptionFormStateReducer,
  getIngressEventSearchListStateReducer,
  searchListInitialState
} from '../service-event-state-manager/ServiceEventStateManager';
import AddExceptionView from './ExceptionViewWrapper';
import classes from './IngressEventAssociationForm.module.scss';

interface IIngressEventAssociationFormProps {
  addEventClicked: boolean;
  editIngressEventButtonClick: boolean;
  onCancelButtonClicked: () => void;
  onSaveEventButtonClick: () => void;
  serviceOperationName: string;
  viewMode?: boolean;
  operationVerb: string;
  ingressEventEditing?: string;
  ingressEventEditingVersion?: string;
}

const defaultProps = {
  viewMode: false,
  ingressEventEditing: '',
  ingressEventEditingVersion: ''
};

const IngressEventAssociationForm = ({
  addEventClicked,
  onCancelButtonClicked,
  onSaveEventButtonClick,
  editIngressEventButtonClick,
  serviceOperationName,
  operationVerb,
  viewMode,
  ingressEventEditing,
  ingressEventEditingVersion,
}: IIngressEventAssociationFormProps) => {
  const { t: translate } = useTranslation();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [json, setJson] = useState({ payload: '', error: '' });
  const [notFoundError, setNotFoundError] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>('');
  const [showJoltModal, setShowJoltModal] = useState(false);
  const [showAiAssistModal, setShowAiAssistModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState('');
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [errorMsg, setErrorMsg] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEventLoading, setIsEventLoading] = useState(false);
  const [jsonInput, setJsonInput] = useState('');
  const [inputType, setInputType] = useState<'json' | 'curl'>('json');
  const [curlInput, setCurlInput] = useState('');

  const [formState, dispatchExceptionState] = useReducer(
    getExceptionFormStateReducer,
    exceptionFormInitialState
  );

  const { serviceType, checkClicked, authDetails } = useSelector((state) => state.serviceDetailsReducer);

  const { handleInputChange, ingressEventFormData, setFormParamValues } = useIngressEventForm();
  const [searchListState, dispatchSearchListState] = useReducer(
    getIngressEventSearchListStateReducer,
    searchListInitialState
  );
  const dispatch = useDispatch<AppDispatch>();
  const { activeServiceEvent, isLoading } = useSelector(
    (state) => state.fetchIngressServiceEventReducer
  );

  const { ingressEventMappingList } = useSelector(
    (state) => state.ingressEventMappingReducer
  );

  const HELPER_TEXT = {
    search_event_ht: translate('helper_text.txt_search_event_ht'),
    jolt_ht: translate('helper_text.txt_jolt_ht'),
    validJson_ht: translate('helper_text.txt_validJson_ht'),
  };

  const { eventDetails, isLoading: isSchemaLoading } = useSelector(
    (state) => state.getEventIdReducer
  );

  const { isEditService } = useSelector((state) => state.serviceOperationMonitorReducer);

  const getSchemaDetails = () => {
    setViewSchemaClicked(true);
    const schemaName = searchListState.searchListData[0]?.eventSchemaId;
    const eventNameValue = searchListState.searchListData[0]?.eventName;
    const versionNumber = searchListState.searchListData[0]?.version;
    if (schemaName) {
      dispatch(fetchEventRequest(eventNameValue, versionNumber));
    }
  };

  const handleShow = () => {
    getSchemaDetails();
    setShow(true);
  };

  const handleModalClose = () => {
    setShow(false);
    setJson({ payload: '', error: '' });
  };

  const [viewSchemaClicked, setViewSchemaClicked] = useState(false);
  const [isGeneratingPayloadToQueryPath, setIsGeneratingPayloadToQueryPath] = useState(false);
  const [isGeneratingPayloadToRequestHeader, setIsGeneratingPayloadToRequestHeader] = useState(false);
  const [options, setOptions] = useState<string[]>([]);
  const [isFormInvalid, setIsFormInvalid] = useState(true);
  const [showPayloadQueryModal, setShowPayloadQueryModal] = useState(false);
  const [showPayloadHeaderModal, setShowPayloadHeaderModal] = useState(false);
  const generateUniqueId = () => Math.random().toString(36).substr(2, 9);
  const [queryPathFields, setQueryPathFields] = useState<Array<{ id: string, value: string }>>([{ id: generateUniqueId(), value: '' }]);
  const [requestHeaderFields, setRequestHeaderFields] = useState<Array<{ id: string, value: string }>>([{ id: generateUniqueId(), value: '' }]);

  useEffect(() => {
    const keys = Object.keys(ingressEventFormData);
    const formValidityArray = keys.filter(
      (key) =>
        !ingressEventFormData[key as keyof IIngressEventValidationModel].isValid
    );
    setIsFormInvalid(searchListState.searchListData.length < 1 || formValidityArray.length > 0);
  }, [searchListState.searchListData, ingressEventFormData]);

  const checkValidity = (): boolean => isFormInvalid;

  const getEventDetails = async () => {
    // if edit event button was click then get data from store and set it to the local variables
    if ((editIngressEventButtonClick || viewMode) && !isEventLoading) {
      const editedEvent: IIngressEventMappingModel | undefined = ingressEventMappingList.find(
        (item) => item.serviceOperationName === serviceOperationName && item.eventName === ingressEventEditing && item.eventVersion === ingressEventEditingVersion
      );
      if (editedEvent) {
        setIsEventLoading(true);
        const { eventData, isError } = await callGetServiceAssociatedEventApi(editedEvent?.eventName ?? '', editedEvent?.eventVersion ?? '');
        if (eventData?.length) {
          const { schema, eventType, eventDescription, eventName, } = eventData[0];
          const activeEvent: IActiveServiceEvent = {
            uuid: '',
            status: '',
            version: Number(editedEvent?.eventVersion),
            createdBy: '',
            createdTimeStamp: null,
            updatedBy: '',
            updatedTimeStamp: null,
            eventId: eventName,
            eventName,
            eventDescription,
            eventType,
            eventCategory: '',
            eventSchemaId: schema,
            eventSchemaVersion: 1,
            eventStatusHistory: []
          };
          const newFormData = new IngressEventFormData();
          newFormData.requestAttribute.value = editedEvent?.reqAttribute ?? '';
          newFormData.requestAttribute.isValid = true;
          newFormData.payloadToQueryPath.value = editedEvent?.payloadToQueryPath as string;
          newFormData.payloadToRequestHeader.value = editedEvent?.payloadToRequestHeader as string;
          newFormData.headerToRequestHeader.value = editedEvent?.headerToRequestHeader as string;
          newFormData.headerToRequestPayload.value = editedEvent?.headerToRequestPayload as string;
          newFormData.requestToAuthenticationPayload.value = editedEvent?.requestToAuthenticationPayload as string;
          newFormData.mqRequestMapping.value = editedEvent?.mqRequestMapping as string;

          setFormParamValues(newFormData);
          dispatchSearchListState({
            type: INGRESS_EVENT_FORM_ACTIONS.SAVE_SEARCH_LIST_DATA,
            addSearchListPayload: { searchListData: [activeEvent] }
          });
          setIsEventLoading(false);
        } else if (isError) {
          setShowModal(true);
          setIsEventLoading(false);
        }
      }
    }
  };

  const callEventDetailsApi = debounce(() => {
    getEventDetails();
  }, DEBOUNCE_DELAY);

  useEffect(() => {
    // if add event button clicked, clear the exception list
    if (addEventClicked) {
      const fields = ['requestAttribute', 'mqRequestMapping', 'payloadToQueryPath', 'payloadToRequestHeader', 'headerToRequestHeader', 'headerToRequestPayload', 'requestToAuthenticationPayload'];
      const formParams = new IngressEventFormData();
      fields.forEach((field) => {
        formParams[field as keyof IngressEventFormData].value = '';
      });
      setFormParamValues(formParams);
    }
    callEventDetailsApi();
  }, [addEventClicked, editIngressEventButtonClick]);

  const [isCancelAddIngressEventClick, setIsCancelAddIngressEventClick] = useState(false);
  /**
   * Performs the action of cancel add ingress event button clicked
   */
  const onCancelAddIngressEventClick = () => {
    onCancelButtonClicked();
    dispatchSearchListState({
      type: INGRESS_EVENT_FORM_ACTIONS.CLEAR_SEARCH_LIST_DATA
    });
    setIsCancelAddIngressEventClick(true);
  };

  /**
   * Handles the input change for search event and makes the api call to find an event
   */
  const handleChange = (value: string) => {
    setInputValue(value);
    dispatchSearchListState({
      type: INGRESS_EVENT_FORM_ACTIONS.SET_SEARCH_VALUE,
      searchValuePayload: { searchValue: value }
    });

    if (value && value.length > 2) {
      setTimeout(() => {
        dispatch(
          fetchServiceEventRequest(value, 'active', associationEventType.INGRESS)
        );
        dispatchSearchListState({
          type: INGRESS_EVENT_FORM_ACTIONS.SET_SEARCH_LIST_VISIBLE,
          searchListVisiblePayload: { searchListVisible: true }
        });
      }, 200);
    } else {
      dispatchSearchListState({
        type: INGRESS_EVENT_FORM_ACTIONS.SET_SEARCH_LIST_VISIBLE,
        searchListVisiblePayload: { searchListVisible: false }
      });
      setOptions([]);
    }
  };

  /**
   * calls on event selected from searched event panel
   */
  const onSelectSearch = (val: string) => {
    setInputValue(val);
    const [eventName, , version] = val.split(' ');
    const versionNumber = +version.split(')')[0];
    setNotFoundError(false);
    const filterList = activeServiceEvent.filter(
      (item) => item.eventName === eventName && item.version === versionNumber
    );
    dispatchSearchListState({
      type: INGRESS_EVENT_FORM_ACTIONS.ON_SEARCH_VALUE_SELECT,
      searchListVisiblePayload: { searchListVisible: false },
      addSearchListPayload: { searchListData: filterList },
      searchValuePayload: { searchValue: val }
    });

    setOptions([]);
  };

  // Update the handler functions (replace the existing ones around lines 297-359)
  const handleSuggestPayloadToQueryPathClick = () => {
    if (!searchListState.searchListData[0]?.eventName) {
      return;
    }
    setShowPayloadQueryModal(true);
  };

  const handleSuggestPayloadToRequestHeaderClick = () => {
    if (!searchListState.searchListData[0]?.eventName) {
      return;
    }
    setShowPayloadHeaderModal(true);
  };

  const handleClosePayloadQueryModal = () => {
    setShowPayloadQueryModal(false);
    setQueryPathFields([{ id: generateUniqueId(), value: '' }]);
  };

  const handleClosePayloadHeaderModal = () => {
    setShowPayloadHeaderModal(false);
    setRequestHeaderFields([{ id: generateUniqueId(), value: '' }]);
  };

  // Add helper functions for managing field arrays
  const addQueryPathField = () => {
    setQueryPathFields([...queryPathFields, { id: generateUniqueId(), value: '' }]);
  };

  const removeQueryPathField = (id: string) => {
    if (queryPathFields.length > 1) {
      setQueryPathFields(queryPathFields.filter((field) => field.id !== id));
    }
  };

  const updateQueryPathField = (id: string, value: string) => {
    setQueryPathFields(queryPathFields.map((field) => (
      field.id === id ? { ...field, value } : field
    )));
  };

  const addRequestHeaderField = () => {
    setRequestHeaderFields([...requestHeaderFields, { id: generateUniqueId(), value: '' }]);
  };

  const removeRequestHeaderField = (id: string) => {
    if (requestHeaderFields.length > 1) {
      setRequestHeaderFields(requestHeaderFields.filter((field) => field.id !== id));
    }
  };

  const updateRequestHeaderField = (id: string, value: string) => {
    setRequestHeaderFields(requestHeaderFields.map((field) => (
      field.id === id ? { ...field, value } : field
    )));
  };

  // Update the generate functions to create JSON with empty values (around line 327 and 368)
  const handleGeneratePayloadToQueryPath = async () => {
    const validFields = queryPathFields.filter((field) => field.value.trim()).map((field) => field.value);
    if (validFields.length === 0) {
      return;
    }

    setIsGeneratingPayloadToQueryPath(true);
    try {
      const eventName = searchListState.searchListData[0]?.eventName;
      const eventVersion = searchListState.searchListData[0]?.version;
      console.log('Event name for payload to query path mapping:', eventName, eventVersion);

      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken.value}`,
      };

      // Create JSON object with empty values and stringify it
      const fieldMapping = validFields.reduce((acc, field) => {
        acc[field] = '';
        return acc;
      }, {} as Record<string, string>);

      const requestBody = {
        outputjson: JSON.stringify(fieldMapping)
      };

      const apiUrl = `${HELP_CENTER_CHATPAGE_SERVICE_BASE_URL}/generate-jolt-from-event?event_name=${eventName}&event_version=${eventVersion}&type=payload-query`;
      const response = await axios.post(apiUrl, requestBody, { headers });

      if (response.data?.jolt_spec && setFormParamValues) {
        setFormParamValues((previousState: IngressEventFormData) => {
          const data = { ...previousState };
          data.payloadToQueryPath.value = JSON.stringify(response.data.jolt_spec, null, 2);
          data.payloadToQueryPath.isValid = true;
          data.payloadToQueryPath.isTouched = true;
          return data;
        });
      }
      handleClosePayloadQueryModal();
    } catch (error) {
      console.error('Error:', error);
      alert('Error generating AI suggestion for Payload to Query Path. Please try again.');
    } finally {
      setIsGeneratingPayloadToQueryPath(false);
    }
  };

  const handleGeneratePayloadToRequestHeader = async () => {
    const validFields = requestHeaderFields.filter((field) => field.value.trim()).map((field) => field.value);
    if (validFields.length === 0) {
      return;
    }

    setIsGeneratingPayloadToRequestHeader(true);
    try {
      const eventName = searchListState.searchListData[0]?.eventName;
      const eventVersion = searchListState.searchListData[0]?.version;
      console.log('Event name for payload to request header mapping:', eventName, eventVersion);

      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken.value}`,
      };

      // Create JSON object with empty values and stringify it
      const fieldMapping = validFields.reduce((acc, field) => {
        acc[field] = '';
        return acc;
      }, {} as Record<string, string>);

      const requestBody = {
        outputjson: JSON.stringify(fieldMapping)
      };

      const apiUrl = `${HELP_CENTER_CHATPAGE_SERVICE_BASE_URL}/generate-jolt-from-event?event_name=${eventName}&event_version=${eventVersion}&type=payload-header`;
      const response = await axios.post(apiUrl, requestBody, { headers });

      if (response.data?.jolt_spec && setFormParamValues) {
        setFormParamValues((previousState: IngressEventFormData) => {
          const data = { ...previousState };
          data.payloadToRequestHeader.value = JSON.stringify(response.data.jolt_spec, null, 2);
          data.payloadToRequestHeader.isValid = true;
          data.payloadToRequestHeader.isTouched = true;
          return data;
        });
      }
      handleClosePayloadHeaderModal();
    } catch (error) {
      console.error('Error:', error);
      alert('Error generating AI suggestion for Payload to Request Header. Please try again.');
    } finally {
      setIsGeneratingPayloadToRequestHeader(false);
    }
  };

  const payloadQueryModalBody = (
    <div className={classes['ai-assist-modal-body']}>
      <div className={classes['upload-section']}>
        <p className={classes['upload-description']}>
          Enter the field names you want to map from the event payload to query path parameters.
        </p>
        {queryPathFields.map((fieldObj, index) => (
          <div key={fieldObj.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '10px' }}>
            <input
              type="text"
              value={fieldObj.value}
              onChange={(e) => updateQueryPathField(fieldObj.id, e.target.value)}
              placeholder={`Field ${index + 1} (e.g., userId, orderId)`}
              style={{
                flex: 1,
                padding: '8px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontSize: '14px'
              }}
            />
            {queryPathFields.length > 1 && (
              <Button
                variant="tertiary"
                onClick={() => removeQueryPathField(fieldObj.id)}
                style={{ minWidth: '40px', padding: '8px' }}
              >
                ✕
              </Button>
            )}

          </div>
        ))}
        <Button
          variant="tertiary"
          onClick={addQueryPathField}
          style={{ marginTop: '10px' }}
        >
          + Add Field
        </Button>
      </div>
    </div>
  );

  const payloadHeaderModalBody = (
    <div className={classes['ai-assist-modal-body']}>
      <div className={classes['upload-section']}>
        <p className={classes['upload-description']}>
          Enter the field names you want to map from the event payload to request headers.
        </p>
        {requestHeaderFields.map((fieldObj, index) => (
          <div key={fieldObj.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '10px' }}>
            <input
              type="text"
              value={fieldObj.value}
              onChange={(e) => updateRequestHeaderField(fieldObj.id, e.target.value)}
              placeholder={`Field ${index + 1} (e.g., correlationId, traceId)`}
              style={{
                flex: 1,
                padding: '8px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontSize: '14px'
              }}
            />
            {requestHeaderFields.length > 1 && (
              <Button
                variant="tertiary"
                onClick={() => removeRequestHeaderField(fieldObj.id)}
                style={{ minWidth: '40px', padding: '8px' }}
              >
                ✕
              </Button>
            )}
          </div>
        ))}
        <Button
          variant="tertiary"
          onClick={addRequestHeaderField}
          style={{ marginTop: '10px' }}
        >
          + Add Field
        </Button>
      </div>
    </div>
  );

  /**
   * Save Ingress EVent in the store
   */
  const saveIngressEvent = () => {
    const selectedEvent = searchListState.searchListData[0];
    const ingressEvent: IIngressEventMappingModel = {
      serviceOperationName,
      eventName: selectedEvent?.eventName,
      eventVersion: String(selectedEvent.version),
      reqAttribute: ingressEventFormData.requestAttribute?.value,
      mqRequestMapping: ingressEventFormData.mqRequestMapping?.value,
      payloadToQueryPath: ingressEventFormData.payloadToQueryPath?.value,
      payloadToRequestHeader: ingressEventFormData.payloadToRequestHeader?.value,
      headerToRequestHeader: ingressEventFormData.headerToRequestHeader?.value,
      headerToRequestPayload: ingressEventFormData.headerToRequestPayload?.value,
      requestToAuthenticationPayload: ingressEventFormData.requestToAuthenticationPayload?.value,
      exceptions: formState.exceptionList
    };
    if (editIngressEventButtonClick) {
      if (ingressEventEditing && ingressEventEditingVersion && selectedEvent.eventName !== ingressEventEditing) {
        dispatch(deleteEgressEventMappingOfIngress({
          serviceOperationName,
          ingressEventName: ingressEventEditing,
          ingressEventVersion: ingressEventEditingVersion
        }));
      }
      dispatch(
        updateIngressEventMapping({
          serviceOperationName,
          ingressEventMapping: ingressEvent,
          ingressEventName: ingressEventEditing ?? '',
          ingressEventVersion: ingressEventEditingVersion ?? '',
        })
      );
    } else {
      dispatch(addIngressEventMapping({ ingressEventMapping: ingressEvent }));
    }
    dispatchSearchListState({
      type: INGRESS_EVENT_FORM_ACTIONS.CLEAR_SEARCH_LIST_DATA
    });
    onSaveEventButtonClick();
  };

  useEffect(() => {
    // to check for duplicate ingress within same sop
    if (searchListState.searchListData.length && searchListState.searchValue !== '') {
      const [selectedEvent] = searchListState.searchListData;
      const ingressEvents = ingressEventMappingList.filter((item) => item.serviceOperationName === serviceOperationName);
      const obj = ingressEvents.filter((item) => item.eventName === selectedEvent.eventName && item.eventVersion === selectedEvent.version.toString());
      if (obj.length) {
        setErrorMsg(true);
      } else {
        setErrorMsg(false);
      }
    }
  }, [searchListState.searchListData]);

  const checkIngressInViewMode = () => {
    if (location.pathname.includes('viewServiceOperation')) {
      return isIngressEventDetailsUpdated(
        ingressEventMappingList,
        serviceOperationName,
        constructIngressEventObject(
          ingressEventFormData,
          serviceOperationName,
          searchListState,
          formState
        )
      );
    }
    return false;
  };

  useEffect(() => {
    setJson(getSchemaForEvent(isSchemaLoading, eventDetails[0].schema, viewSchemaClicked, json));
  }, [eventDetails, isSchemaLoading]);

  useEffect(() => {
    if (activeServiceEvent.length > 0) {
      const filteredData = activeServiceEvent.map((item) => `${item.eventName} (${VER} ${item.version})`);
      setOptions(filteredData);
      setNotFoundError(false);
    } else if (inputValue.length > 2 && !isLoading) {
      setOptions([]);
      setNotFoundError(true);
    }
  }, [activeServiceEvent]);

  const onFileUploadSuccess = (fileData: string) => {
    const newFormData = { ...ingressEventFormData };
    newFormData.mqRequestMapping.value = fileData;
    setFormParamValues(newFormData);
  };

  const getEditViewIngressEventTitle = () => {
    if (getModeFromUrl() === SERVICE_MODE.VIEW) {
      return translate('service_event_form.lbl_view_ingress_event');
    }
    if (editIngressEventButtonClick) {
      return translate('service_event_form.lbl_edit_ingress_event');
    }
    return translate('service_event_form.lbl_add_ingress_event');
  };

  // Shows the error message in autoComplete
  const notFoundErrorMsg = inputValue && notFoundError ? (translate('service_event_form.lbl_no_match_found')) : '';
  const autoCompleteErrorMsg = inputValue && searchListState.searchListData.length > 0 && !notFoundError
    && errorMsg ? (translate('service_event_association.lbl_duplicate_ingress_event')) : notFoundErrorMsg;

  const onModalClose = () => {
    setShowModal(false);
    onCancelButtonClicked();
  };

/**
   * @method handleAiAssistModalClick
   * @description Handles the click event for the AI Assist modal.
   */
  const handleAiAssistModalClick = () => {
    if (!viewMode) {
      setShowAiAssistModal(true);
    }
  };

  /**
   * @description Closes the AI Assist modal dialog.
   */
  const handleCloseAiAssistModalDialog = () => {
    setShowAiAssistModal(false);
    setSelectedFile(null);
    setFileName('');
    setJsonInput(''); // Clear the JSON input when closing modal
    setCurlInput(''); // Clear the cURL input when closing modal
  };

  const handleInputTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputType(event.target.value as 'json' | 'curl');
  };

  /**
   * @method handleFileChange
   * @description Handles file selection for AI Assist.
   */
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setFileName(file.name);
    }
  };

  /**
   * @method handleFileUploadClick
   * @description Triggers the file input click.
   */
  const handleFileUploadClick = () => {
    fileInputRef.current?.click();
  };

  // Add headers function for authorization
  const headersInstance = () => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken.value}`,
  });

  /**
   * @method handleGenerateSchema
   * @description Handles the schema generation from uploaded file.
   */
  const handleGenerateSchema = async () => {
    console.log('handleGenerateSchema called'); // Debug log
    console.log('inputType:', inputType); // Debug log
    console.log('jsonInput:', jsonInput); // Debug log
    console.log('curlInput:', curlInput); // Debug log
    const inputData = inputType === 'json' ? jsonInput : curlInput;
    if (inputData.trim()) {
      try {
        let requestPayload;
        if (inputType === 'json') {
          // Validate that the input is valid JSON
          const parsedJson = JSON.parse(jsonInput);
          console.log('JSON is valid'); // Debug log
          // Convert the JSON input to the required format
          requestPayload = {
            outputjson: JSON.stringify(parsedJson)
          };
          console.log('Formatted JSON request payload:', requestPayload); // Debug log
        } else {
          // For cURL, pass the raw cURL command as string in outputjson field
          requestPayload = {
            outputjson: curlInput.trim()
          };
          console.log('Formatted cURL request payload:', requestPayload); // Debug log
        }
        // Get event name and version from the selected event details
        const eventName = searchListState.searchListData[0]?.eventName;
        const version = searchListState.searchListData[0]?.version;
        console.log('Event info from searchListData:', { eventName, version }); // Debug log
        if (!eventName || !version) {
          console.error('Event name or version not available from selected event details');
          console.error('searchListData:', searchListState.searchListData); // Debug log
          return;
        }
        // Make API call to generate JOLT mapping using POST
        const apiUrl = `${HELP_CENTER_CHATPAGE_SERVICE_BASE_URL}/generate-jolt-from-event?event_name=${eventName}&event_version=${version}&type=rq-attr`;
        console.log('Making API call to:', apiUrl); // Debug log
        console.log('Request payload:', requestPayload); // Debug log
        const response = await axios.post(apiUrl, requestPayload, {
          headers: headersInstance(),
        });
        console.log('API response:', response.data); // Debug log
        if (response.data) {
          // Extract jolt_spec from the response
          const joltSpec = response.data.jolt_spec;
          if (joltSpec) {
            // Update the JOLT mapping textarea using setFormParamValues
            setFormParamValues((previousState) => {
              const data = structuredClone(previousState);
              data.requestAttribute.isValid = true;
              data.requestAttribute.value = JSON.stringify(joltSpec, null, 2); // Pretty format the jolt_spec JSON
              data.requestAttribute.isTouched = true;
              data.requestAttribute.error = '';
              return data;
            });
            console.log('JOLT mapping updated with jolt_spec'); // Debug log
          } else {
            console.error('No jolt_spec found in response');
          }
        }
        handleCloseAiAssistModalDialog();
      } catch (error) {
        console.error('Error generating JOLT mapping:', error);
        // You might want to show an error message to the user here
        if (axios.isAxiosError(error)) {
          console.error('API Error:', error.response?.data || error.message);
        } else if (inputType === 'json' && error instanceof Error) {
          console.error('Invalid JSON format:', error);
        }
      }
    } else {
      console.log('No input provided'); // Debug log
    }
  };

  const shouldShowEventDetails = (searchListState.searchListData.length > 0 || editIngressEventButtonClick) && !errorMsg;

  const isNotDB2AndSOAP = serviceType !== SERVICE_TYPE_KEY.SOAP && serviceType !== SERVICE_TYPE_KEY.DB2;

  const isNotSOAP = serviceType !== SERVICE_TYPE_KEY.SOAP;

  const aiAssistModalBody = (
    <div className={classes['ai-assist-modal-body']}>
      <div className={classes['upload-section']}>
        <h6>{translate('schema_details_form_components.ai_assist_modal_upload_title')}</h6>
        <p className={classes['upload-description']}>
          {translate('service_event_form.ai_assist_modal_upload_description')}
        </p>
        {/* Radio buttons for input type selection */}
        <div className={classes['input-type-selection']}>
          <Radio
            id="json-input"
            name="inputType"
            value="json"
            checked={inputType === 'json'}
            onChange={handleInputTypeChange}
            label="JSON Input"
          />
          <Radio
            id="curl-input"
            name="inputType"
            value="curl"
            checked={inputType === 'curl'}
            onChange={handleInputTypeChange}
            label="cURL Input"
          />
        </div>

        {/* Conditional textarea based on selected input type */}
        {inputType === 'json' ? (
          <Textarea
            label="Output JSON Input"
            name="jsonInput"
            value={jsonInput}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setJsonInput(e.target.value)}
            style={{ height: '400px', minHeight: '400px', maxHeight: 'none' }}
            placeholder="Paste your Output JSON here"
            maxLength="1048576" // 1MB limit - very high
          />
        ) : (
          <Textarea
            label="cURL Command Input"
            name="curlInput"
            value={curlInput}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setCurlInput(e.target.value)}
            style={{ height: '400px', minHeight: '400px', maxHeight: 'none' }}
            placeholder="Paste your cURL command here"
            maxLength="1048576" // 1MB limit - very high
          />
        )}
      </div>
    </div>
  );

  return (
    <div>
      <Loader show={isEventLoading} />
      <Modal
        modalShow={showModal}
        modalTitle={translate('service_wrapper_component.lbl_confirm_error_title')}
        modalBody={translate('service_wrapper_component.msg_api_error')}
        btnSaveText={String(translate('service_wrapper_component.lbl_close'))}
        onSaveModal={onModalClose}
        onCloseModal={onModalClose}
        alignToCentre
        data-testid="activeStatusEditWarningModalNodeConfirm"
        disableCloseBtn={false}
        disableSaveBtn={false}
        type="warning"
      />
      <Form className={classes['event-form']}>
        <Row>
          <div className={classes['ingress-title']}>
            <Button variant="primary" className={classes['back-btn']} onClick={onCancelAddIngressEventClick} aria-label="ingress back button"><i className="bi bi-chevron-left" /></Button>
            <div>
              <div className={classes['ingress-event-header']}>{getEditViewIngressEventTitle()}</div>
              <div className={classes['ingress-event-desc']}>{translate('service_event_form.desc_ingress_event')}</div>
            </div>
          </div>
        </Row>
        <Col className={classes['input-container']}>
          {!(viewMode || (isEditService && editIngressEventButtonClick))
            && (
              <Row>
                <Col sm={5}>
                  <div className={classes['search-input']}>
                    <AutoComplete
                      labelText={String(translate('service_event_form.lbl_search_existing_event'))}
                      infoIconTxt={String(translate('service_event_form.ingress_search_info_bubble'))}
                      suggestions={options}
                      onSelect={onSelectSearch}
                      onqueryUpdate={handleChange}
                      isLoading={isLoading}
                      placeHolder={translate('event_list_component.plcd_lbl_search_event')}
                      clearData={false}
                      isDisabled={viewMode || (isEditService && editIngressEventButtonClick)}
                      minSearchLength={3}
                      helperText={HELPER_TEXT.search_event_ht}
                      fieldName={AUTOCOMPLETE_FIELD.eventName}
                      error={notFoundError || (searchListState.searchListData.length > 0 && !notFoundError && errorMsg)}
                      errorTxt={autoCompleteErrorMsg}
                    />
                  </div>
                </Col>
              </Row>
            )}
          {shouldShowEventDetails && (
            <Row className={classes['header-event-details']}>
              {translate('service_event_form.lbl_event_details')}
            </Row>
          )}
          {shouldShowEventDetails && (
            <Row>
              <div className={classes['event-details-container']}>
                <div className={classes.details}>
                  <div>{translate('service_event_form.lbl_event_name')}</div>
                  <span className={classes['details-info']}>
                    {searchListState.searchListData[0]?.eventName}
                  </span>
                </div>
                <div className={classes.details}>
                  <div>{translate('service_event_form.lbl_event_version')}</div>
                  <span className={classes['details-info']}>
                    {searchListState.searchListData[0]?.version}
                  </span>
                </div>
                <div className={classes.details}>
                  <div>
                    {translate('service_event_form.lbl_event_type_form')}
                  </div>
                  <span className={classes['details-info']}>
                    {searchListState.searchListData[0]?.eventType}
                  </span>
                </div>
                <div className={classes.details}>
                  <div>{translate('service_event_form.lbl_description')}</div>
                  <span className={classes['details-info']}>
                    {searchListState.searchListData[0]?.eventDescription}
                  </span>
                </div>
                <div className={classes['view-schema']}>
                  <span
                    onClick={handleShow}
                    onKeyDown={() => { }}
                    role="button"
                    tabIndex={-1}
                    className=""
                    data-testid="view-schema"
                  >
                    {translate('service_event_form.lbl_view_schema')}
                  </span>
                </div>
              </div>
            </Row>
          )}
          {shouldShowEventDetails && (
          <div>
            {serviceType !== SERVICE_TYPE_KEY.DB2 && (
            <Row className={classes['event-details-header']}>
              <Col>
                <CILabel id="requestAttribute" labelText={translate('service_event_form.lbl_request_attribute_mapping')} />
              </Col>
              <Col className={classes['jolt-config-beta-link']}>
                <div className={classes['button-group']}>
                  <Button
                    variant="tertiary"
                    className={classes['ai-assist-btn']}
                    onClick={handleAiAssistModalClick}
                    disabled={viewMode}
                    data-testid="ai-assist-btn"
                  >
                    <small>{translate('service_event_form.ai_assist')}</small>
                    <CIInfoIcon iconTxt={String(translate('service_event_form.ai_assist_info_bubble'))} />
                  </Button>
                  <span className={classes['btn-beta-text']}>{translate('schema_details_form_components.beta_title')}</span>
                </div>
                <div className={classes['button-group']}>
                  <Button
                    variant="tertiary"
                    className={classes['configure-jolt-btn']}
                    onClick={() => setShowJoltModal(true)}
                  >
                    <small> {translate('service_event_form.configure_jolt_btn')}</small>
                  </Button>
                  <span className={classes['btn-beta-text']}>{translate('schema_details_form_components.beta_title')}</span>
                </div>
              </Col>
            </Row>
              )}
            {serviceType !== SERVICE_TYPE_KEY.DB2 && (
            <Row className={classes['text-area']}>
              <Textarea
                id="requestAttribute"
                placeholder={String(translate('event_list_component.txt_add_jolt'))}
                name="requestAttribute"
                label=""
                value={ingressEventFormData.requestAttribute.value}
                onChange={handleInputChange}
                maxLength="524288"
                disabled={viewMode}
                data-testid="requestAttribute"
                helperText={HELPER_TEXT.jolt_ht}
                error={!ingressEventFormData.requestAttribute.isValid}
                errorTxt={ingressEventFormData.requestAttribute.error}
              />
            </Row>
              )}
            {operationVerb === OPERATION_VERB[10].name && (
            <Row className={classes['event-details-header']}>
              <div className={classes['copybook-container']}>
                <CILabel id="mqRequestMapping" labelText={translate('service_event_form.lbl_mq_message_attribute_mapping')} />

                <FileUploadButton viewMode={viewMode ?? false} onFileUploadSuccess={onFileUploadSuccess} />
              </div>
            </Row>
              )}
            {operationVerb === OPERATION_VERB[10].name && (
            <Row className={classes['text-area']}>
              <Textarea
                placeholder={String(translate(
                      'service_event_form.lbl_mq_message_attribute_mapping'
                    ))}
                name="mqRequestMapping"
                id="mqRequestMapping"
                label=""
                value={ingressEventFormData.mqRequestMapping.value}
                onChange={handleInputChange}
                maxLength=""
                disabled
                data-testid="mqRequestMapping"
              />
              <div className={classes['error-container']} />
            </Row>
              )}
            {isNotSOAP && (
            <Row className={`${classes['text-area']} mt-3`}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <CILabel id="payloadToQueryPath" labelText={String(translate('service_event_form.lbl_payload_to_query_path'))} />
                {!viewMode && (
                <div className="jolt-config-beta-link">
                  <div className="button-group">
                    <Button
                      variant="tertiary"
                      className="configure-jolt-btn"
                      onClick={handleSuggestPayloadToQueryPathClick}
                      disabled={!searchListState.searchListData[0]?.eventName || isGeneratingPayloadToQueryPath}
                      data-testid="suggest-payload-query-path-btn"
                    >
                      <small>{isGeneratingPayloadToQueryPath ? 'Generating...' : 'AI Assist'}</small>
                      <CIInfoIcon iconTxt={String(!searchListState.searchListData[0]?.eventName ? 'Select an event first' : 'Get AI suggestion for payload to query path mapping')} />
                    </Button>
                    <span className="btn-beta-text">[Beta]</span>
                  </div>
                </div>
                    )}
              </div>
              <Textarea
                placeholder={String(translate('service_event_form.lbl_add_valid_json'))}
                name="payloadToQueryPath"
                label=""
                value={ingressEventFormData.payloadToQueryPath.value}
                onChange={handleInputChange}
                maxLength=""
                disabled={viewMode}
                data-testid="payloadToQueryPath"
                helperText={HELPER_TEXT.validJson_ht}
                error={!ingressEventFormData.payloadToQueryPath.isValid}
                errorTxt={ingressEventFormData.payloadToQueryPath.error}
              />
            </Row>
              )}
              {isNotDB2AndSOAP && (
                <Row className={`${classes['text-area']} mt-3`}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <CILabel id="payloadToRequestHeader" labelText={String(translate('service_event_form.lbl_payload_to_request_header'))} />
                    {!viewMode && (
                      <div className="jolt-config-beta-link">
                        <div className="button-group">
                          <Button
                            variant="tertiary"
                            className="configure-jolt-btn"
                            onClick={handleSuggestPayloadToRequestHeaderClick}
                            disabled={!searchListState.searchListData[0]?.eventName || isGeneratingPayloadToRequestHeader}
                            data-testid="suggest-payload-request-header-btn"
                          >
                            <small>{isGeneratingPayloadToRequestHeader ? 'Generating...' : 'AI Assist'}</small>
                            <CIInfoIcon iconTxt={String(!searchListState.searchListData[0]?.eventName ? 'Select an event first' : 'Get AI suggestion for payload to request header mapping')} />
                          </Button>
                          <span className="btn-beta-text">[Beta]</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <Textarea
                    placeholder={String(translate('service_event_form.lbl_add_valid_json'))}
                    name="payloadToRequestHeader"
                    label=""
                    value={ingressEventFormData.payloadToRequestHeader.value}
                    onChange={handleInputChange}
                    maxLength=""
                    disabled={viewMode}
                    data-testid="payloadToRequestHeader"
                    helperText={HELPER_TEXT.validJson_ht}
                    error={!ingressEventFormData.payloadToRequestHeader.isValid}
                    errorTxt={ingressEventFormData.payloadToRequestHeader.error}
                  />
                </Row>
              )}
              {isNotSOAP && (
                <Row className={`${classes['text-area']} mt-3`}>
                  <Textarea
                    labelText={String(translate('service_event_form.lbl_header_to_request_header'))}
                    placeholder={String(translate('service_event_form.lbl_add_valid_json'))}
                    name="headerToRequestHeader"
                    label=""
                    value={ingressEventFormData.headerToRequestHeader.value}
                    onChange={handleInputChange}
                    maxLength=""
                    disabled={viewMode}
                    helperText={HELPER_TEXT.validJson_ht}
                    error={!ingressEventFormData.headerToRequestHeader.isValid}
                    errorTxt={ingressEventFormData.headerToRequestHeader.error}
                  />
                </Row>
              )}

              {serviceType === SERVICE_TYPE_KEY.REST && (
                <Row className={`${classes['text-area']} mt-3`}>
                  <Textarea
                    labelText={String(translate('service_event_form.lbl_header_to_request_payload'))}
                    placeholder={String(translate('service_event_form.lbl_add_valid_json'))}
                    name="headerToRequestPayload"
                    label=""
                    value={ingressEventFormData.headerToRequestPayload.value}
                    onChange={handleInputChange}
                    maxLength=""
                    disabled={viewMode}
                    helperText={HELPER_TEXT.validJson_ht}
                    error={!ingressEventFormData.headerToRequestPayload.isValid}
                    errorTxt={ingressEventFormData.headerToRequestPayload.error}
                  />
                </Row>
              )}
              {serviceType === SERVICE_TYPE_KEY.REST && (
                <Row className={`${classes['text-area']} mt-3`}>
                  <Textarea
                    labelText={String(translate('service_event_form.lbl_request_to_authentication_payload'))}
                    placeholder={String(translate('service_event_form.lbl_add_valid_json'))}
                    name="requestToAuthenticationPayload"
                    label=""
                    value={ingressEventFormData.requestToAuthenticationPayload.value}
                    onChange={handleInputChange}
                    maxLength={Number.MAX_SAFE_INTEGER}
                    disabled={viewMode || !(checkClicked && authDetails?.authType === AUTH_TYPE_NAME.OAUTH)}
                    helperText={HELPER_TEXT.validJson_ht}
                    error={!ingressEventFormData.requestToAuthenticationPayload.isValid}
                    errorTxt={ingressEventFormData.requestToAuthenticationPayload.error}
                  />
                </Row>
              )}
          </div>
          )}

          {shouldShowEventDetails && (
            <>
              <Row className={classes['event-details-header']}>
                <div>{translate('service_event_form.lbl_exception')}</div>
              </Row>
              <Row className={classes['event-details-sub-header']}>
                <div>{translate('service_event_form.lbl_exceptions_sub_header')}
                </div>
              </Row>
            </>
          )}
          {shouldShowEventDetails && (
            <Row>
              <div className={classes.exception}>
                <fieldset disabled={viewMode}>
                  <AddExceptionView
                    viewMode={viewMode ?? false}
                    addEventClicked={addEventClicked}
                    editIngressEventButtonClick={editIngressEventButtonClick}
                    serviceOperationName={serviceOperationName}
                    isCancelAddIngressEventClick={isCancelAddIngressEventClick}
                    formState={formState}
                    dispatchExceptionState={dispatchExceptionState}
                  />
                </fieldset>
              </div>
            </Row>
          )}
        </Col>
        <div className={`${classes['btn-container']} ci-button-group`}>
          <Button
            className={classes['btn-cancel']}
            onClick={onCancelAddIngressEventClick}
            data-testid="btn-cancel"
            variant="secondary"
          >
            {translate('service_wrapper_component.lbl_cancel')}
          </Button>
          <Button
            className={classes['btn-add']}
            disabled={
              checkValidity()
              || errorMsg
              || checkIngressInViewMode()
              || getModeFromUrl() === SERVICE_MODE.VIEW
            }
            onClick={saveIngressEvent}
            data-testid="btn-save"
            variant="primary"
          >
            {(isEditService || editIngressEventButtonClick) ? (translate('service_wrapper_component.lbl_save_ingress')) : (translate('service_wrapper_component.lbl_add_ingress'))}
          </Button>
        </div>
      </Form>
      <EventSchemaTree show={show} closeModal={handleModalClose} json={json} getSchemaIsLoading={isSchemaLoading} />
      <Modal modalTitle={translate('event_list_component.txt_jolt_config')} modalBody={<JoltConfigurations />} className="modal-xl" modalShow={showJoltModal} onCloseModal={() => setShowJoltModal(false)} />
      <Modal
        modalTitle={translate('service_event_form.ai_assist_modal_title')}
        btnCloseText={String(translate('service_event_form.ai_assist_modal_cancel'))}
        btnSaveText={String(translate('service_event_form.ai_assist_modal_generate_button'))}
        modalBody={aiAssistModalBody}
        modalShow={showAiAssistModal}
        onCloseModal={handleCloseAiAssistModalDialog}
        onSaveModal={handleGenerateSchema}
        alignToCentre
        disableSaveBtn={inputType === 'json' ? !jsonInput.trim() : !curlInput.trim()}
        disableCloseBtn={false}
        className={classes['ai-assist-modal']}
      />
      <Modal
        modalTitle="AI Assist - Payload to Query Path Mapping"
        btnCloseText="Cancel"
        btnSaveText={isGeneratingPayloadToQueryPath ? 'Generating...' : 'Generate Mapping'}
        modalBody={payloadQueryModalBody}
        modalShow={showPayloadQueryModal}
        onCloseModal={handleClosePayloadQueryModal}
        onSaveModal={handleGeneratePayloadToQueryPath}
        alignToCentre
        disableSaveBtn={queryPathFields.filter((field) => field.value.trim()).length === 0 || isGeneratingPayloadToQueryPath}
        disableCloseBtn={isGeneratingPayloadToQueryPath}
        className={classes['ai-assist-modal']}
      />
      <Modal
        modalTitle="AI Assist - Payload to Request Header Mapping"
        btnCloseText="Cancel"
        btnSaveText={isGeneratingPayloadToRequestHeader ? 'Generating...' : 'Generate Mapping'}
        modalBody={payloadHeaderModalBody}
        modalShow={showPayloadHeaderModal}
        onCloseModal={handleClosePayloadHeaderModal}
        onSaveModal={handleGeneratePayloadToRequestHeader}
        alignToCentre
        disableSaveBtn={requestHeaderFields.filter((field) => field.value.trim()).length === 0 || isGeneratingPayloadToRequestHeader}
        disableCloseBtn={isGeneratingPayloadToRequestHeader}
        className={classes['ai-assist-modal']}
      />
    </div>
  );
};
IngressEventAssociationForm.defaultProps = defaultProps;
export default IngressEventAssociationForm;
